"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20Revert__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610226806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c806323b872dd14610030575b600080fd5b61004a60048036038101906100459190610120565b61004c565b005b6040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161007e906101d0565b60405180910390fd5b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006100b78261008c565b9050919050565b6100c7816100ac565b81146100d257600080fd5b50565b6000813590506100e4816100be565b92915050565b6000819050919050565b6100fd816100ea565b811461010857600080fd5b50565b60008135905061011a816100f4565b92915050565b60008060006060848603121561013957610138610087565b5b6000610147868287016100d5565b9350506020610158868287016100d5565b92505060406101698682870161010b565b9150509250925092565b600082825260208201905092915050565b7f626164207468696e672068617070656e65640000000000000000000000000000600082015250565b60006101ba601283610173565b91506101c582610184565b602082019050919050565b600060208201905081810360008301526101e9816101ad565b905091905056fea264697066735822122016a748576fdd0b976c82c85159f327481398ef9d4160ac785a99597b5afbe6fc64736f6c63430008090033";
class ERC20Revert__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20Revert__factory = ERC20Revert__factory;
ERC20Revert__factory.bytecode = _bytecode;
ERC20Revert__factory.abi = _abi;
